import { ChipProps, Chip } from '@mui/material';
import { get } from 'lodash';
import { ReactElement } from 'react';
import { useRecordContext, Labeled } from 'react-admin';
import { BidResource } from '../../Entities/Bid';
import { APPROVAL_STATUS_CHOICES, APPROVAL_STATUS } from './utils';
import { match } from 'ts-pattern';

export function ApprovalStatusField(): ReactElement {
  const record = useRecordContext<BidResource>();
  const status = Number(get(record, 'attributes.approval_status'));
  const label = APPROVAL_STATUS_CHOICES.find(({ id }) => id === status)?.name ?? 'Pending';
  const color = match<number, ChipProps['color']>(status)
    .with(APPROVAL_STATUS.APPROVED, () => 'primary')
    .with(APPROVAL_STATUS.REJECTED, () => 'error')
    .otherwise(() => 'default');

  return (
    <Labeled label="Approval Status">
      <Chip color={color} label={label} size="small" sx={{ cursor: 'default' }} />
    </Labeled>
  );
}
